import store from "../store";
import toolUtils from "./toolUtils";

var mixin1 = {
    computed: {
        isFollow() {
            return this.$store.state.accounts[0];
        },
        networkID() {
            return this.$store.state.networkIDstring;
        }
    },
    watch: {
        async isFollow(newVal, oldVal) {
            console.log("newVal", newVal, "oldVal", oldVal);

            // 重置数据为空
            if (newVal === undefined) {
                if (this.$route.path.toString().indexOf('/index') >= 0) {

                } else if (this.$route.path.toString().indexOf('/mint') >= 0) {
                    await this.resetMintData();
                }
            }

            // 刷新数据
            if (oldVal === undefined && newVal !== undefined && newVal !== null) {
                store.commit('setState', {
                    accounts: [newVal]
                });

                if (this.$route.path.toString().indexOf('/index') >= 0) {

                } else if (this.$route.path.toString().indexOf('/mint') >= 0) {
                    await this.initMintData();
                }
            }
        },
        networkID(newVal, oldVal) {
            console.log("newVal", newVal, "oldVal", oldVal);
        }
    },
    methods: {
        onAccountsChanged: function () {
            var _this = this;

            if (window.ethereum) {
                window.ethereum.on('accountsChanged', function (accounts) {
                    _this.onRefresh(accounts);
                });
                //监听网络切换
                window.ethereum.on('networkChanged', function (networkIDstring) {
                    if (networkIDstring != null) {
                        if (parseInt(networkIDstring) === 56) {
                            store.commit("setState", {
                                networkIDstring,
                            });
                        }

                        _this.initRefreshNetwork();
                    }
                });
            }

            if (window.okxwallet) {
                window.okxwallet.on('accountsChanged', function (accounts) {
                    _this.onRefresh(accounts);
                });
                //监听网络切换
                window.okxwallet.on('networkChanged', function (networkIDstring) {
                    if (networkIDstring != null) {
                        if (parseInt(networkIDstring) === 56) {
                            store.commit("setState", {
                                networkIDstring,
                            });
                        }

                        _this.initRefreshNetwork();
                    }
                });
            }

            if (window.tokenpocket.ethereum) {
                window.tokenpocket.ethereum.on('accountsChanged', function (accounts) {
                    _this.onRefresh(accounts);
                });
                //监听网络切换
                window.tokenpocket.ethereum.on('networkChanged', function (networkIDstring) {
                    if (networkIDstring != null) {
                        if (parseInt(networkIDstring) === 56) {
                            store.commit("setState", {
                                networkIDstring,
                            });
                        }

                        _this.initRefreshNetwork();
                    }
                });
            }
        }
    }
}

export { mixin1 }
